import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
import SaveIcon from '@material-ui/icons/Save'

// Custom Component
import useLoading from "../Loading/useLoading"
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import FullScreenDialog from '../Dialog/FullScreenDialog'
import WebViewerDRRelatedItem from "../WebViewer/WebViewerDRRelatedItem"
import CreateRelatedItemForm from "./CreateRelatedItemForm"
import ViewRelatedItemForm from "./ViewRelatedItemForm"
import DrawingGeneralRevisionTable from "./DrawingGeneralRevisionTable"

// Custom Style
// import {whiteColor, blackColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import drawingGeneralStyle from '../../styles/jss/components/drawingRegister/drawingGeneralStyle'

// Global Function
// import {webViewerLoadDocument} from "../../global/webViewerLoadDocument"

// Fetch Data


const useStyles = makeStyles(theme => drawingGeneralStyle(theme))

const DrawingGeneral = props => {
	const {drawingDetailRecord, selectedRevisionSeq, setSelectedRevisionSeq, setDrawingRefash, setAnnotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()

	const [createItemDialogOpen, setCreateItemDialogOpen] = useState(false)
	const [viewItemDialogOpen, setViewItemDialogOpen] = useState(false)
	const [relatedItemSaveResult, setRelatedItemSaveResult] = useState(null)
	const [selectedRelatedItemSeq, setSelectedRelatedItemSeq] = useState(null)
	const [withChangeManagement, setWithChangeManagement] = useState(false)
	const [webViewerProps, setWebViewerProps] = useState(null)


	// Alert dialog control state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog control State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})

	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}


	// Confirm Dialog Control Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Dialog open and close contral
	const createRelatedItemDialogHandleOpen = () => {
		setWithChangeManagement(true)
		setCreateItemDialogOpen(true)
	}

	const createRelatedItemDialogHandleClose = () => {
		setCreateItemDialogOpen(false)
	}


	// Dialog open and close contral
	const viewRelatedItemDialogHandleOpen = () => {
		setViewItemDialogOpen(true)
	}

	const viewRelatedItemDialogHandleClose = () => {
		setViewItemDialogOpen(false)
	}


	// Action
	const saveAnnotationConfirmAction = () => {
		confirmDialogHandleOpen({
			dialogTitle: "Annotation Save",
			dialogContent: "Are you sure to save all annotation change.",
			confirmAction: saveAnnotationAction,
			cancelAction: saveAnnotationCancelAction
		})
	}

	const saveAnnotationAction = async () => {
		setWithChangeManagement(false)
		setRelatedItemSaveResult(Math.random())
		store.set('annotActive', false)
		saveAnnotationCancelAction()
		
	}

	const saveAnnotationCancelAction = () => {
		confirmDialogHandleClose()
	}


	useEffect(() => {
		setAnnotSaveChangeAction(() => saveAnnotationAction)
	}, [])


	return (
		// console.log("Drawing Detail Record | Variable: drawingDetailRecord (DrawingGeneral.js)"),
		// console.log(drawingDetailRecord),

		// console.log("Selected Revision Seq | Variable: selectedRevisionSeq (DrawingGeneral.js)"),
		// console.log(selectedRevisionSeq),

		// console.log("Related Item Seq for display selected related item | Variable: selectedRelatedItemSeq (DrawingGeneral.js)"),
		// console.log(selectedRelatedItemSeq),

		// console.log("Related Item Seq for save into annotation | Variable: relatedItemSaveResult (DrawingGeneral.js)"),
		// console.log(relatedItemSaveResult),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				<FullScreenDialog
					open={createItemDialogOpen}
					dialogTitle={"Create Item"}
					formContent={
						<CreateRelatedItemForm
							relatedItemType={"All"}
							createMethod={"IN_VIEWER"}
							drawingDetailRecord={drawingDetailRecord}
							selectedRevisionSeq={selectedRevisionSeq}
							setRelatedItemSaveResult={setRelatedItemSaveResult}
							dialogHandleClose={createRelatedItemDialogHandleClose}
						/>
					}
					button={[]}
					handleClose={createRelatedItemDialogHandleClose}
				/>

				<FullScreenDialog
					open={viewItemDialogOpen}
					dialogTitle={"Related Item Detail"}
					formContent={
						<ViewRelatedItemForm
							drawingDetailRecord={drawingDetailRecord}
							selectedRevisionSeq={selectedRevisionSeq}
							selectedRelatedItemSeq={selectedRelatedItemSeq}
							viewRelatedItemDialogHandleClose={viewRelatedItemDialogHandleClose}
							setDrawingRefash={setDrawingRefash}
						/>
					}
					button={[]}
					handleClose={viewRelatedItemDialogHandleClose}
				/>
			</div>

			<div  className={classes.drawingTable}>
				<DrawingGeneralRevisionTable
					drawingDetailRecord={drawingDetailRecord}
					setSelectedRevisionSeq={setSelectedRevisionSeq}
					setWebViewerProps={setWebViewerProps}
					setDrawingRefash={setDrawingRefash}
					annotSaveChangeAction={saveAnnotationAction}
				/>
			</div>


			<div className={classes.toolMenu}>
				<Tooltip title="Save Annotation">
					<Fab 
						color="primary"
						size="small"
						onClick={saveAnnotationConfirmAction}
						className={classes.toolMenuBtn}
					>
						<SaveIcon />
					</Fab>
				</Tooltip>
			</div>

			<div>
				<WebViewerDRRelatedItem
					property={webViewerProps}
					relatedItemSaveResult={relatedItemSaveResult}
					setSelectedRelatedItemSeq={setSelectedRelatedItemSeq}
					withChangeManagement={withChangeManagement}
					openCreateDialog={createRelatedItemDialogHandleOpen}
					openViewDialog={viewRelatedItemDialogHandleOpen}
				/>
			</div>

			{/* <div  className={classes.drawingTable}>
				<DrawingGeneralRevisionTable
					drawingDetailRecord={drawingDetailRecord}
					setSelectedRevisionSeq={setSelectedRevisionSeq}
					setWebViewerProps={setWebViewerProps}
					setDrawingRefash={setDrawingRefash}
				/>
			</div> */}
		</Fragment>
	)
}


export default DrawingGeneral